import React from "react";
import Image from "../../elements/Image";
import paypalImg from "../../../assets/images/paypal.svg";
import stripeImg from "../../../assets/images/stripe.svg";
import { t } from "i18next";

const PaymentButtons = ({
  onPaymentHandler = () => {},
  loading,
  stripe,
  paypal,
}) => {
  return (
    <div className="flex gap-4 justify-center mt-6">
      {/* Stripe Button */}
      {stripe && (
        <button
          type="submit"
          disabled={loading}
          className="border border-blue-600 hover:bg-blue-700/10 flex items-center gap-2 text-blue-600 font-bold py-2 px-6 rounded-lg shadow-md transition duration-300 disabled:opacity-50"
          onClick={() => onPaymentHandler({ type: "stripe" })}
        >
          {loading && (
            <i className="fa-duotone fa-solid fa-spinner-third animate-spin"></i>
          )}
          {t("Pay with")}{" "}
          <Image alt={"stripe"} src={stripeImg} classes={"w-10"} />
        </button>
      )}

      {/* PayPal Button */}
      {paypal && (
        <button
          type="submit"
          disabled={loading}
          className="border border-yellow-500 bg-yellow-500 hover:bg-yellow-600 flex items-center gap-3 text-black font-bold py-2 px-6 rounded-lg shadow-md transition duration-300 disabled:opacity-50"
          onClick={() => onPaymentHandler({ type: "paypal" })}
        >
          {loading && (
            <i className="fa-duotone fa-solid fa-spinner-third animate-spin"></i>
          )}
          {t("Pay with")}{" "}
          <Image alt={"paypal"} src={paypalImg} classes={"w-8"} />
        </button>
      )}
    </div>
  );
};

export default PaymentButtons;
